/*global FB, window */
var $ = require('jquery');
var ShareButton = require('diy/social/ShareButton');
var websiteData = require('diy/util/websiteData');

var FacebookShare;


/**
 * @class diy.social.FacebookShare
 * @template diy.social.FacebookShare
 * @lends {diy.social.FacebookShare.prototype}
 * @extends {diy.social.ShareButton}
 * @constructor
 */
FacebookShare = ShareButton.extend({
    /**
     * @type {{
     *      appId: String
     *      onClick: Function,
     *      onSubmit: Function,
     *      onSubmitCanceled: Function,
     *      image: String,
     *      url: String,
     *      actions: Array.<{name: String, link: String}>
     * }}
     */
    options: undefined,
    /**
     *
     * @param {*} options
     * @private
     * @returns {diy.social.FacebookShare}
     */
    setOptions: function (options) {
        var
            defaults = {
                appId: '',
                onClick: undefined,
                onSubmit: undefined,
                onSubmitCanceled: undefined,
                image: websiteData.getCdnUrl() + 's/diy/social/img/facebook/facebook_' + this.market + '.png',
                url: websiteData.getWebUrl(),

                actions: []
            };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     * @private
     * @returns {Promise|Q.promise}
     */
    loadApi: function () {
        var
            deferred = Q.defer(),
            languageCode;

        if (!!$('#fb-root').length) {
            deferred.resolve(true);
        } else {
            window.fbAsyncInitOptions = {
                appId: this.options.appId,
                xfbml: true,
                version: 'v2.3'
            };
            window.fbAsyncInit = function () {
                FB.init(window.fbAsyncInitOptions);
                deferred.resolve(true);
            };

            $('body').append('<div id="fb-root"></div>');
            languageCode = (this.locale === 'es_MX') ? 'es_ES' : this.locale;
            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/" + languageCode + "/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

        }
        return deferred.promise;
    },
    /**
     * @private
     */
    createButton: function () {
        var $share;

        this.$element.addClass('diy-share-facebook');
        $share = $('<img src="' + this.options.image + '">').appendTo(this.$element);

        $share.css({cursor: 'pointer'});
        $share.bind('click', this.onClick.bind(this));
    },
    /**
     * @private
     */
    onClick: function () {
        this.executeCallback(this.options.onClick);

        window.FB.ui(
            {
                method: 'feed',
                link: this.options.url,
                actions: this.options.actions
            },
            this.onSubmit.bind(this)
        );

    },
    /**
     * @param {{undefined|{post_id: String|undefined}} callbackData
     * @private
     */
    onSubmit: function (callbackData) {
        switch (true) {
            // canceled the post
            case (callbackData === null):
                this.executeCallback(this.options.onSubmitCanceled);
                break;
            // posted to facebook, so we have a valid post_id
            case (callbackData !== null && typeof callbackData === 'object' && callbackData.hasOwnProperty('post_id')):
                this.executeCallback(this.options.onSubmit, callbackData);
                break;
        }
    }
});

module.exports = FacebookShare;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/social/FacebookShare.js
 ** module id = 735
 ** module chunks = 0
 **/